class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('.predictive-search-input');
    this.input2 = document.querySelector('#Search-In-Modal');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.predictiveSearchResults2 = document.querySelector('.innerPredictiveSearch');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

     this.input2.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }


  onChange() {
    const searchTerm = this.input.value.trim();
    const searchTerm2 = this.input2.value.trim();

    const finalTerm = searchTerm?.length > 0 ? searchTerm : searchTerm2;
    
    if (!finalTerm.length) {
      this.close();
      return;
    }


      this.getSearchResults(finalTerm, searchTerm?.length > 0 ? 'bar': 'modal');
  }

  getSearchResults(searchTerm, barOrModal) {
    this.isBar = barOrModal == 'bar'?true:false;
    
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        if(this.isBar){
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        } else {
          console.log('predictiveSearchResults2', this.predictiveSearchResults2);
        this.predictiveSearchResults2.innerHTML = resultsMarkup;
        }
        this.open();
      })
      .catch((error) => {
        console.log(error);
        this.close();
        throw error;
      });
  }

  open() {
        if(this.isBar){
            this.predictiveSearchResults.style.display = 'block';
        } else {
            this.predictiveSearchResults2.style.display = 'block';
        }
  }

  close() {
        if(this.isBar){
    this.predictiveSearchResults.style.display = 'none';
        } else {
    this.predictiveSearchResults2.style.display = 'none';
          
        }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
